import React from "react";
import { Play } from "lucide-react";
import ComingSoonFormat from "@/components/site/ComingSoonFormat";

export default function Watch() {
  return (
    <ComingSoonFormat
      testId="watch-page"
      label="Watch"
      Icon={Play}
      headline="Video is next."
      description="Short operator lessons, interview excerpts, full conversations, and visual frameworks. Built around the same standard as the written interviews: real operators, real decisions, no theatre."
      bullets={[
        "60-second operator lessons pulled from full interviews.",
        "Longer video conversations with contributors.",
        "Visual explainers of common operating problems.",
        "Short case studies drawn from real companies.",
      ]}
    />
  );
}
